import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import TableRowSkeleton from "../../../components/skeletons/TableRowSkeleton";

const SettlementRequestsListSkeleton = () => {
  return (
    <>
      <Grid
        container
        flexDirection={"column"}
        flexWrap={"unset"}
        height={"85vh"}
        gap={"10px"}
      >
        <Grid item sx={{ height: "80%" }}>
          <TableRowSkeleton rowsNum={5} columnsNum={12} />
        </Grid>
        <Grid
          item
          sx={{
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "end",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "end",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Box>
              <Box
                sx={{
                  background: "#F9FAFC",
                  borderRadius: "5px",
                  border: "1px solid #DAE0E4",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px",
                  gap: "15rem",
                }}
              >
                <Typography sx={{ color: "#1D4A87", fontSize: "1rem" }}>
                  جمع کل (ریال):
                </Typography>
                <Typography
                  sx={{
                    color: "#1D4A87",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  0
                </Typography>
              </Box>
            </Box>
            <Button
              variant="contained"
              fullWidth
              className={"btnForm SuccessDefault"}
              sx={{ maxWidth: "160px" }}
            >
              ثبت اولیه
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default SettlementRequestsListSkeleton;
